module.exports = __webpack_public_path__ + "static/SoleilBlack-bab15b4e2541442610d84f0194d35358.otf";